export class TeamMember {
    _id: string;
    name: string;
    title: string;
    department: string;
    image_path: string;
    active: any;
    sort_order: number;
    createdAt: Date;
    updatedAt: Date;
    // Filter props
    hasSearchTerms: boolean;
    searchText: string;
    dateCreatedRange; // For filters
    dateCreated; // For filters
    dateCreatedEnd; // For filters
}
